import { apiCall } from '../../../../../../common/api/api'
import { Matricula } from '../../Domain/Matricula'
import { Vehicle } from '../../../../../../common/types/Vehiculo'
import { mapVehiculoMatriculaApiToVehicles } from './mapVehicleApiResponse'

const baseUrl = `${process.env.GATSBY_API_URL}`

export const apiVehiculo = {
  async obtenerPorMatricula(matricula: Matricula): Promise<Vehicle[]> {
    const json = await apiCall(`${baseUrl}/vehiculos/${matricula.value()}`, {
      method: 'GET',
    })
    return mapVehiculoMatriculaApiToVehicles(json)
  },
}
